import { config } from "../config";
import { Http } from "./http";

export const adminApiRequest = new Http(`${config.ADMIN_API_URL}`);
export const apiRequest = new Http(`${config.API_URL}`);
